import { Pipe, PipeTransform } from '@angular/core';
import { Utilities } from '../utilities/utilities';
import { LanguageService } from '../services/language.service';

@Pipe({name: 'salonMonsterDate', pure: false})
export class SalonMonsterDatePipe implements PipeTransform {

  constructor(private languageService: LanguageService) {}

  transform(value: Date | null | undefined, formatStr: string = 'yyyy-MM-dd HH:mm:ss') : string {
    if (!value || !(value instanceof Date) || isNaN(value.getTime())) {
      return '';
    }
    return Utilities.formatDate(value, formatStr, this.languageService.getCurrentLanguage());
  }
}